import { fcaFastApi, fcaReportGateway } from "../../services/authorizationService";
import * as serviceEndpoints from "../../config/serviceEndPoints";

export const getSoftCostsData = params =>
    fcaFastApi.get(`${params.recommendation_id ? serviceEndpoints.softCosts.recommendationSoftCosts : serviceEndpoints.softCosts.softCosts}`, {
        params
    });
export const saveSoftCostsData = data =>
    fcaFastApi.post(
        `${data.recommendation_id ? serviceEndpoints.softCosts.saveRecommendationSoftCosts : serviceEndpoints.softCosts.saveSoftCosts}`,
        data
    );
export const saveDynamicSoftCostField = data => fcaFastApi.post(`${serviceEndpoints.softCosts.saveDynamicSoftCostField}`, data);
export const updateDynamicSoftCostField = data => fcaFastApi.put(`${serviceEndpoints.softCosts.updateDynamicSoftCostField}${data?.id}/`, data);
export const deleteDynamicSoftCostField = (id, params) =>
    fcaFastApi.delete(`${serviceEndpoints.softCosts.updateDynamicSoftCostField}${id}/`, { params });
export const exportExcel = (payload, fileType) => {
    const url = fileType === "word" ? serviceEndpoints.softCosts.exportWord : serviceEndpoints.softCosts.exportExcel;

    return fcaReportGateway.post(url, payload, { method: "POST", responseType: "blob" });
};
export const resetSoftCost = id => fcaFastApi.delete(`${serviceEndpoints.softCosts.resetSoftCost}${id}`);
export const syncProjectCost = data => fcaFastApi.post(`${serviceEndpoints.softCosts.syncProjectCost}`, data);
